import React from 'react';
import AdminDashboardTopBarComponent from './admin-dashboard-topbar.component';

export default function AdminDashbordTopBar(props) {
    return <AdminDashboardTopBarComponent {...props} />;
}
